
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/signup",
      function () {
        return require("private-next-pages/_sites/[site]/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/signup"])
      });
    }
  